import { aggregationSeparator } from './constants';
import { CategoryEnum } from '../../search.types';

export function expendFlattenedAggregationsForRequest(
  aggregationsPaths: string[],
) {
  const result: { [key in CategoryEnum]?: Array<Array<string> | string> } = {};
  const alreadyAdded: { [key in CategoryEnum]?: string[] } = {};

  aggregationsPaths.forEach((pathString) => {
    const [type, ...path] = pathString.split(aggregationSeparator) as [
      CategoryEnum,
      string,
    ];

    if (!result[type]) {
      result[type] = [];
    }

    if (alreadyAdded[type] === undefined) {
      alreadyAdded[type] = [];
    }

    path.forEach((value, index) => {
      if (index === 0 && !alreadyAdded[type]!.includes(value)) {
        alreadyAdded[type]!.push(value);

        result[type]!.push(value);
      } else if (index > 0) {
        const subPath = path.slice(0, index + 1);
        const subPathKey = subPath.join(aggregationSeparator);

        if (!alreadyAdded[type]!.includes(subPathKey)) {
          alreadyAdded[type]!.push(subPathKey);

          result[type]!.push(subPath);
        }
      }
    });
  });

  return result;
}
